// This is a part of the Cadcorp SIS source code. 
// Copyright (c) Cadcorp Limited 1991-2026 
import { ILocation, IPositionTransformer, GeoLocatorErrorEnum } from '../../../../CommonScripts/Abstractions';
import Vuex from 'vuex';
/**
* Encapsulates the browser geolocation api 
*/
export class Geolocator {
    /**
    * @oublic
    * @property {object} positionOptions - Geolocation PositionOptions
    * @memberof Cadcorp.Web.Core.GeoLocator#
    */
    positionOptions: PositionOptions;
    /**
    * @private
    * @property {boolean} m_active - True if the control currently active
    */
    private m_active: boolean;

    /**
    * @constructor
    * @public
    * @param { PositionOptions } positionOptions options for the Location api.
    */
    constructor(positionOptions: PositionOptions) {
        this.positionOptions = positionOptions;
        this.m_active = false;
    }

    /**
     * Check HTML5 browser compatibility.
     * @public
     * @returns {boolean} If true, HTML5 geolocation is available.
     */
    available(): boolean {
        return ('geolocation' in navigator);
    }

    /**
     * Activates the GeoLocator. Attempt to use HTML5 GeoLocation, triggering relevant events.
     * @public
     */
    activate(): Promise<GeolocationPosition> {
        var retVal = null;
        if (this.available()) {
            retVal = new Promise(
                (resolve, reject) =>
                    navigator.geolocation.getCurrentPosition(resolve, reject, this.positionOptions));
        }
        else {
            retVal = Promise.reject({ code: GeoLocatorErrorEnum.UnCapable});
        }
        return retVal;
    }
    /**
     * Create a GeoLocationPosition object.
     * @public
     * @param {number} lon The longitude returned from the geolocation api
     * @param {number} lat The latitude returned from the geolocation api
     * @param {string} epsg The epsg code for the coordinates returned from the geolocation api
     * @returns {ILocation} An object that implements ILocation
     */
    public createLocation(lon:number, lat: number, epsg : string): ILocation{
        return {
            x: lon,
            y: lat,
            epsgCode: epsg
        };
    }
}

export class OlCoordPositionTransformer implements IPositionTransformer {
    constructor() {
    }
    transform(location : ILocation) :any {
        return [location.x, location.y];
    }
}


